import React from 'react';
import { Target, Lightbulb, TrendingUp } from 'lucide-react';
export function MissionVision() {
  return <section className="py-16 bg-white -mt-10 relative z-20" data-id="element-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-301">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-302">
          {/* Mission */}
          <div className="bg-white p-8 rounded-2xl shadow-xl border-t-4 border-green-600 hover:transform hover:-translate-y-2 transition-all duration-300" data-id="element-303">
            <div className="w-14 h-14 bg-green-100 rounded-full flex items-center justify-center mb-6" data-id="element-304">
              <Target className="h-7 w-7 text-green-700" data-id="element-305" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-306">
              Our Mission
            </h3>
            <p className="text-gray-600 leading-relaxed" data-id="element-307">
              To produce high-quality, nutritious dairy products through
              sustainable farming practices that honor our heritage while
              embracing modern agricultural innovation.
            </p>
          </div>

          {/* Vision */}
          <div className="bg-white p-8 rounded-2xl shadow-xl border-t-4 border-amber-500 hover:transform hover:-translate-y-2 transition-all duration-300" data-id="element-308">
            <div className="w-14 h-14 bg-amber-100 rounded-full flex items-center justify-center mb-6" data-id="element-309">
              <Lightbulb className="h-7 w-7 text-amber-600" data-id="element-310" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-311">
              Our Vision
            </h3>
            <p className="text-gray-600 leading-relaxed" data-id="element-312">
              To be the leading model of sustainable dairy farming in Kenya,
              empowering our community and setting the standard for agricultural
              excellence in Nyandarua.
            </p>
          </div>

          {/* Future Goal */}
          <div className="bg-green-900 p-8 rounded-2xl shadow-xl border-t-4 border-green-400 hover:transform hover:-translate-y-2 transition-all duration-300" data-id="element-313">
            <div className="w-14 h-14 bg-green-800 rounded-full flex items-center justify-center mb-6" data-id="element-314">
              <TrendingUp className="h-7 w-7 text-green-300" data-id="element-315" />
            </div>
            <h3 className="text-2xl font-bold text-white mb-4" data-id="element-316">
              2028 Inspiration
            </h3>
            <p className="text-green-100 leading-relaxed" data-id="element-317">
              Our strategic goal is to transition fully to a high-yield pedigree
              herd by 2028, maximizing production while maintaining the highest
              standards of animal welfare.
            </p>
          </div>
        </div>
      </div>
    </section>;
}